<template>
  <div>
    <!-- <v-card-title class="elevation-0">
      <span class="itemHeading">LEAVE BALANCE</span>
    </v-card-title> -->
    <v-tabs v-model="tabValue" background-color="white" grow dark center-active centered :show-arrows="true"
      active-class="activ" class="nonactiv" style="font-family: kumbhSemibold">
      <v-tabs-slider color="#005f32"></v-tabs-slider>
      <v-tab href="#tab-1"><span style="color: black">My Leave Balance</span></v-tab>
      <v-tab href="#tab-2"><span style="color: black">Team Members’ Leave Balance</span></v-tab>
      <v-tab-item value="tab-1">
        <v-card flat>
          <v-layout wrap justify-start py-5>
            <v-flex xs12 sm6 md3 pl-3 pb-3>
              <v-select
                v-model="leaveType"
                :items="leaveTypes"
                label="Leave Type"
                class="rounded-xl"
                outlined
                dense
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6 md3 pl-3 pb-3>
              <v-select
                v-model="fyear"
                :items="yearItems"
                item-text="text"
                item-value="value"
                :label="yearLabel"
                class="rounded-xl"
                outlined
                dense
              ></v-select>
            </v-flex>
            <v-flex xs12 pl-3 text-left>
              <LeaveBalanceTable
                :view-type="'my'"
                :current-page="currentPage"
                :leave-type="leaveType"
                :fyear="fyear"
                @page-changed="onPageChanged"
                :key="tabValue + leaveType + fyear"
              />
            </v-flex>
          </v-layout>
        </v-card>
      </v-tab-item>
      <v-tab-item value="tab-2">
        <v-card flat>
          <v-layout wrap justify-end py-5>
            <v-flex xs12 sm6 md3 pl-3 pb-3>
              <v-select
                v-model="leaveType"
                :items="leaveTypes"
                label="Leave Type"
                class="rounded-xl"
                outlined
                dense
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6 md3 pl-3 pb-3>
              <v-select
                v-model="fyear"
                :items="yearItems"
                item-text="text"
                item-value="value"
                :label="yearLabel"
                class="rounded-xl"
                outlined
                dense
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6 md3 pl-3 pb-3>
              <v-text-field
                v-model="searchQuery"
                label="Search"
                class="rounded-xl"
                prepend-inner-icon="mdi-magnify"
                clearable
                @input="onSearch"
                outlined
                dense
              ></v-text-field>
            </v-flex>
            <v-flex xs12 pl-3 text-left>
              <LeaveBalanceTable
                :view-type="'team'"
                :current-page="currentPage"
                :search-query="searchQuery"
                :leave-type="leaveType"
                :fyear="fyear"
                :employee-id="employeeId"
                @page-changed="onPageChanged"
                :key="tabValue + leaveType + fyear + (employeeId || '')"
              />
            </v-flex>
          </v-layout>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import LeaveBalanceTable from './LeaveBalanceTable.vue';

export default {
  components: {
    LeaveBalanceTable
  },
  data() {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
    let startYear = currentMonth >= 3 ? currentYear : currentYear - 1;
    const fyears = [];
    const festivalYears = [];
    for (let i = 0; i < 5; i++) {
      fyears.push({ text: `${startYear - i}-${startYear - i + 1}`, value: `${startYear - i}-${startYear - i + 1}` });
      festivalYears.push({ text: `${startYear - i}`, value: `${startYear - i}` });
    }
    const initialSearch = (this.$route && this.$route.query) ? (this.$route.query.search || this.$route.query.name || this.$route.query.empname || '') : '';
    const initialEmployeeId = (this.$route && this.$route.query) ? (this.$route.query.employeeId || null) : null;
    const initialTab = initialSearch ? 'tab-2' : 'tab-1';
    return {
      tabValue: initialTab,
      currentPage: 1,
      searchQuery: initialSearch,
      employeeId: initialEmployeeId,
      leaveType: 'Casual',
      leaveTypes: ['Casual', 'Festival'],
      fyear: fyears[0].value,
      fyears: fyears,
      festivalYears: festivalYears
    };
  },
  computed: {
    yearItems() {
      return this.leaveType === 'Festival' ? this.festivalYears : this.fyears;
    },
    yearLabel() {
      return this.leaveType === 'Festival' ? 'Year' : 'Financial Year';
    }
  },
  watch: {
    tabValue(newVal, oldVal) {
      if (oldVal) {
        this.currentPage = 1; // Reset page when tab changes
        this.searchQuery = ''; // Reset search query when tab changes
      }
    },
    '$route.query': {
      handler(newQuery) {
        if (newQuery && (newQuery.search || newQuery.name || newQuery.empname)) {
          this.tabValue = 'tab-2';
          this.searchQuery = newQuery.search || newQuery.name || newQuery.empname;
        }
      },
      immediate: true
    },
    leaveType(newVal) {
      this.currentPage = 1; // Reset page when leave type changes
      if (newVal === 'Festival') {
        this.fyear = this.festivalYears[0].value;
      } else {
        this.fyear = this.fyears[0].value;
      }
    }
  },
  methods: {
    onPageChanged(page) {
      this.currentPage = page;
    },
    onSearch() {
      this.currentPage = 1; // Reset to first page on search
    }
  }
};
</script>

<style>
.itemHeading {
  font-size: 22px;
  font-family: kumbhSemibold;
  color: #005f32;
}
</style>